import { Stack, Typography } from '@mui/material';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { DashboardCustomizeRounded } from '@mui/icons-material';

type Template = {
    id: string;
    name: string;
    description?: string | null;
    numberOfWidgets?: number;
};
type ActionResponse = Template[];

export type AndieSearchDashboardTemplatesProps = ActionRenderAi<ActionResponse>;

/** Template name/description come from the backend as i18n keys; translate them like the rest of the app. */
const TemplatesList = ({ result }: ActionRenderAi<ActionResponse>) => {
    const { t, i18n } = useTranslation();
    const templates = Array.isArray(result) ? result : [];

    const label = (key?: string | null) => {
        if (!key) return '';
        return i18n.exists(key) ? t(key) : key;
    };

    return (
        <Stack gap={0.5} py={0.5}>
            {templates.map((template) => (
                <Typography key={template.id} variant="caption" color="text.secondary">
                    • {label(template.name)}
                </Typography>
            ))}
        </Stack>
    );
};

const AndieSearchDashboardTemplates = (props: AndieSearchDashboardTemplatesProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse>
            title={() => t('andie.tool.search-dashboard-templates.title')}
            icon={<DashboardCustomizeRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.search-dashboard-templates.loading')]}
            completeMessage={({ result }) =>
                t('andie.tool.search-dashboard-templates.complete', {
                    value: result && Array.isArray(result) ? result.length : 0,
                })
            }
            additionalComponent={TemplatesList}
            {...props}
        />
    );
};

export default AndieSearchDashboardTemplates;
